module.exports = __webpack_public_path__ + "img/bg-trailer.bae63c54.jpg";